import CRUDService from "./geral/CRUDService";

export default class CompetenciaCargoService extends CRUDService{
    constructor() {
        super("competenciacargo");
    }
}